import {
  Chip,
  Dialog,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import dayjs from "dayjs";
import { Cross, Recce } from "../assets/icons";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import Styles from "../../styles/vendorDashboard.module.css";
import { Link } from "react-router-dom";
import Decrypt from "../utils/Decrypt";
import CapitalizeFirstLetter from "../utils/CapitalizeFirstLetter";

const columns = [
  {
    field: "serial",
    headerName: "NO. ",
    width: 20,
  },
  { field: "campaign", headerName: "CAMPAIGN", width: 100 },
  { field: "service", headerName: "SERVICE", width: 80 },
  { field: "jobId", headerName: "JOB ID", width: 60 },
  { field: "KAM", headerName: "KAM", width: 60 },
  { field: "storeDetail", headerName: "STORE DETAILS", width: 200 },
  { field: "jobDate", headerName: "JOB DATE", width: 120 },
  { field: "completionDate", headerName: "COMPLETION DATE", width: 120 },
  { field: "paymentDate", headerName: "PAYMENT DATE", width: 120 },
  { field: "buget", headerName: "BUDGET", width: 70 },
  { field: "images", headerName: "IMAGES  ", width: 120 },
  { field: "paymentStatus", headerName: "PAYMENT STATUS", width: 50 },
  // { field: "action", headerName: "ACTION", width: 60 },
];

const IpPaymentsModal = ({
  selectedInstallationPartnerData,
  ipModalOpen,
  setIpModalOpen,
  ipCampaignData,
  ipData,
}) => {
  const handleClose = () => {
    setIpModalOpen(false);
  };

  return (
    <Dialog open={ipModalOpen} fullScreen fullWidth>
      <div className=" px-16 md:px-24 py-5 relative">
        <div className="flex justify-between gap-3 mt-5">
          <div className="flex items-start justify-center gap-4 rounded-xl ">
            <div className=" h-[110px] w-[110px] object-contain">
              <img
                src={
                  ipData?.profilePhoto
                    ? ipData?.profilePhoto
                    : "/assests/AdminDashboard/userForIP.webp"
                }
                alt="profilePic"
                className="rounded-md h-full w-full object-fit"
              />
            </div>
            <div>
              <h1 className="tex-[20px] font-bold">
                {CapitalizeFirstLetter(ipData?.name)}
              </h1>
              <p>
                {ipData?.city}, {ipData?.state}, {ipData?.zipCode}
              </p>
              <p>{Decrypt(ipData?.emailAddress)}</p>
              <p>{Decrypt(ipData?.phoneNumber)}</p>
            </div>
          </div>

          <div>
            <div
              onClick={handleClose}
              className="mx-5 my-4 flex justify-end absolute right-1 top-1"
              style={{ cursor: "pointer" }}
            >
              <Cross />
            </div>
            <p>
              Total Campaigns :{" "}
              <span className="text-[var(--heading-color)] font-semibold">
                {ipCampaignData?.totalCampaigns || 0}
              </span>
            </p>
            <p>
              Pending Campaigns :{" "}
              <span className="text-[var(--heading-color)] font-semibold">
                {ipCampaignData?.pendingCampaigns || 0}
              </span>
            </p>
            <p>
              Total Earned :{" "}
              {
                <CurrencyRupeeIcon
                  style={{
                    fontSize: "12px",
                    marginBottom: 2,
                    color: "var(--heading-color)",
                  }}
                />
              }
              <span className="text-[var(--heading-color)] font-semibold">
                {ipCampaignData?.totalEarnedAmount || 0}
              </span>
            </p>
          </div>
        </div>
      </div>
      <Grid>
        <>
          <TableContainer
            sx={{
              height: "calc(85vh - 97px)",
              maxHeight: "calc(85vh - 97px)",
              maxWidth: "calc(88vw - 0px)",
              width: "calc(88vw - 0px)",

              overflowY: "auto",
            }}
            className={`mt-2  border rounded-md mx-auto ${Styles["custom-scrollbar"]}`}
          >
            <Table
              stickyHeader
              aria-label="customized table"
              className="rounded-lg"
            >
              <TableHead>
                <TableRow>
                  {columns.map((column, index) => (
                    <TableCell
                      key={column.field}
                      sx={{
                        minWidth: column.width,
                        fontWeight: "bold",
                      }}
                    >
                      <span className="text-[12px]">{column.headerName}</span>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {selectedInstallationPartnerData &&
                selectedInstallationPartnerData?.length > 0 ? (
                  selectedInstallationPartnerData?.map((row, index) => {
                    // const isRowSelected = selected.includes(row.id);
                    return (
                      <TableRow
                        key={index}
                        hover
                        // selected={isRowSelected}
                        sx={{
                          // borderRight: "1px solid #ccc",
                          cursor: "pointer",
                        }}
                      >
                        <TableCell>{index + 1}</TableCell>
                        <TableCell
                        // sx={{
                        //   borderRight: "1px solid #ccc",
                        //   padding: "4px 8px",
                        // }}
                        >
                          <p className="text-[12px]">
                            {" "}
                            {row?.job?.campaignId?.campaignTitle}{" "}
                          </p>
                        </TableCell>
                        <TableCell>
                          <p className="text-[12px] flex justify-start items-center gap-2">
                            <Recce size="16" color="var(--para-color)" />
                            {row?.job?.serviceType == 0
                              ? "Recce"
                              : "Installation"}
                          </p>
                        </TableCell>
                        <TableCell>
                          <p className="text-[12px]">
                            {" "}

                            #{row?.job?._id.slice(-6)}{" "}

                          </p>
                        </TableCell>
                        <TableCell>
                          <p className="text-[12px]">
                            {" "}
                            {row?.job?.campaignId?.keyAccountManagerName ||
                              "N/A"}{" "}
                          </p>
                        </TableCell>
                        <TableCell>
                          <p className="text-[12px]">
                            {row.job ? (
                              <>
                                {row?.job?.storeOwnerName}
                                <br />
                                <span className="text-[10px]">
                                  {row?.job?.storeName}
                                </span>
                              </>
                            ) : (
                              "N/A"
                            )}
                          </p>
                        </TableCell>
                        <TableCell>
                          <p className="text-[12px]">
                            {row?.job?.jobStartingDate
                              ? dayjs(row.job.jobStartingDate).format(
                                  "DD/MM/YYYY"
                                )
                              : "N/A"}
                          </p>
                        </TableCell>
                        <TableCell>
                          <p className="text-[12px]">
                            {row?.job?.jobCompletionDate
                              ? dayjs(row.job.jobCompletionDate).format(
                                  "DD/MM/YYYY"
                                )
                              : "N/A"}
                          </p>
                        </TableCell>
                        <TableCell>
                          <p className="text-[12px]">
                            {row?.paymentDate
                              ? dayjs(row.paymentDate).format("DD/MM/YYYY")
                              : "N/A"}
                          </p>
                        </TableCell>
                        <TableCell>
                          <p className="text-[12px]">
                            ₹ {row?.amountPaid || "N/A"}
                          </p>
                        </TableCell>
                        <TableCell>
                          <p className="text-[12px]">
                            {" "}
                            <Link to={""}>View Images</Link>
                          </p>
                        </TableCell>

                        <TableCell>
                          <Chip
                            label={
                              row?.salaryCredited ? "Done" : "Pending" || "N/A"
                            }
                            sx={{
                              backgroundColor: row?.salaryCredited
                                ? "var(--green-bgChip-color)" // Light yellow background similar to bg-yellow-100
                                : "var(--yellow-bgChip-color)",
                              color: row?.salaryCredited
                                ? "var(--textChip-green-color)" // Text color similar to text-yellow-500
                                : "var(--textChip-yellow-color)",
                              fontWeight: "bold",
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <div className="flex justify-center items-center h-96 w-full">
                        No Payments found
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      </Grid>
    </Dialog>
  );
};

export default IpPaymentsModal;
